import FamilyLogo from 'images/logo/familyLogo.svg';
import HomeChefLogoWithText from 'images/logo/homeChefWithText.svg';
import { FAMILY, STANDARD } from 'lib/constants';

const PlanCardData = {
  standard: {
    logo: HomeChefLogoWithText,
    subheader: '2-serving meal kits and beyond',
    pointers: [
      'Variety of flavors for every palate',
      'Easy prep, no mess options',
      'Meals that meet your dietary needs',
    ],
    ctaText: 'Continue with Home Chef Plan',
    plan: STANDARD,
  },
  family: {
    logo: FamilyLogo,
    subheader: 'Cooking for families of all sizes',
    pointers: [
      'Crowd-pleasing flavors for picky eaters',
      'Convenient weeknight dinners',
      'One-pot and one-pan options',
    ],
    ctaText: 'Continue with Family Plan',
    plan: FAMILY,
  },
};

export default PlanCardData;
